
// Registration API so digitization tools and their categories are data, not
// hard-coded UI. Any module can call DigitizationTools.register(...) /
// DigitizationCategories.register(...) at load time to extend the
// Digitalisering section without touching DigitizationModule or the sidebar.

import {localizeFields} from "./i18n/index.js";

// Tekstfelterne i en værktøjs-/kategoridefinition skrives som T("dansk tekst") og oversættes, når de læses (i18n/index.js)
const TOOL_TEXT_FIELDS = ["name", "tooltip", "instructions", "featureType", "description", "title"];
const CATEGORY_TEXT_FIELDS = ["name", "description"];

const categories = [];
const tools = [];

export const DigitizationCategories = {
	register(category){
		if(categories.find(c => c.id === category.id)) return;
		categories.push(localizeFields(category, CATEGORY_TEXT_FIELDS));
	},
	list(){
		return categories.slice().sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
	},
};

export const DigitizationTools = {
	register(tool){
		if(tools.find(t => t.id === tool.id)) return;
		tools.push(localizeFields(tool, TOOL_TEXT_FIELDS));
	},
	list(){
		return tools.slice();
	},
	byCategory(categoryId){
		return tools.filter(t => t.category === categoryId);
	},
	get(toolId){
		return tools.find(t => t.id === toolId);
	},
};
